// import { store } from '@/store'
import { auth } from "@/fireinit.js";

export default (to, from, next) => {
  if (auth.currentUser) {
    next();
  } else {
    next("/");
  }
};
